<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="flex flex-wrap justify-center align-middle">
        <div class="w-full text-gray-400 text-sm text-left">
            {{ row.reference }}
        </div>
        <div v-if="row.order.serial_number" class="w-full mt-1 text-gray-500 text-xs text-left">
            {{ $t('common.sn_colon') }} {{ row.order.serial_number }}
        </div>
    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReturnOrderIdentificationCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
